import React, { useEffect, useState } from "react";
import InputCommon from "components/inputCommon";
import { RootStateOrAny, useSelector } from "react-redux";
import { BeatLoader } from "react-spinners";
import * as Styles from "../../styles";
import { AuthState } from "../../../../store/ducks/auth/types";
import ComboBoxCommon from "../../../comboBoxCommon";
import { useAlterarTelefones } from "../../../../services/api/AppWeb_Lead/alterar-telefones";

interface Props {
  closeModal: Function;
  phone1: string | null;
  phone2: string | null;
  phone3: string | null;
  phonePrincipal: number | null | undefined;
  idLead: string | undefined | any;
  idLeadCorretor: string | undefined | any;
  telefoneOrigemInformado: boolean | undefined;
}

const LeadPhonesModal = (props: Props) => {
  const { codigoCargo2013 }: any = useSelector<RootStateOrAny, AuthState>(
    (state) => state.user
  );
  const isCorretor: any =
    codigoCargo2013 === "219.840.002" ||
    codigoCargo2013 === "219.840.012" ||
    codigoCargo2013 === "219.840.001";
  const [phone1, setPhone1] = useState(props?.phone1 ? props.phone1 : "");
  const [phone2, setPhone2] = useState(props?.phone2 ? props.phone2 : "");
  const [phone3, setPhone3] = useState(props?.phone3 ? props.phone3 : "");
  const [phonePrincipal, setPhonePrincipal] = useState(
    props?.phonePrincipal ? props.phonePrincipal : 1
  );

  const { mutate, isLoading, isSuccess } = useAlterarTelefones({
    idLeadCorretor: props?.idLead === undefined ? "" : props?.idLeadCorretor,
    body: {
      idLead: props?.idLead === undefined ? "" : props?.idLead,
      telefones: [
        {
          telefone: phone1,
          telefonePrincipal: phonePrincipal === 1,
          codigoCampoTelefone: 1,
        },
        {
          telefone: phone2,
          telefonePrincipal: phonePrincipal === 2,
          codigoCampoTelefone: 2,
        },
        {
          telefone: phone3,
          telefonePrincipal: phonePrincipal === 3,
          codigoCampoTelefone: 3,
        },
      ],
    },
  });

  useEffect(() => {
    if (isSuccess) {
      props?.closeModal();
    }
  }, [isSuccess]);

  return (
    <>
      <Styles.ContentModal>
        <Styles.InfoModal style={{ marginBottom: 8 }}>
          O corretor pode <span>alterar e adicionar</span> até 3 telefones de
          contato, além de definir qual é o <span>contato principal</span>!
        </Styles.InfoModal>
        <Styles.Text style={{ margin: "0" }}>Telefone 1</Styles.Text>
        <InputCommon
          isError={false}
          type="phone"
          isDisabledPhone={
            props?.telefoneOrigemInformado
              ? props?.telefoneOrigemInformado
              : false
          }
          placeholder="Telefone de origem"
          helperText=""
          value={phone1}
          onChange={(event: string) => {
            setPhone1(event);
          }}
        />
        {isCorretor ? (
          <ComboBoxCommon
            value={1}
            valueSelected={phonePrincipal}
            onValueSelected={(val) => setPhonePrincipal(val)}
            text="Telefone principal"
          />
        ) : null}
        <Styles.Text style={{ margin: "8px 0 0 0" }}>Telefone 2</Styles.Text>
        <InputCommon
          isDisabled={!isCorretor}
          isError={false}
          type="phone"
          placeholder="Telefone 2"
          helperText=""
          value={phone2}
          onChange={(event: string) => {
            setPhone2(event);
          }}
        />
        {isCorretor ? (
          <ComboBoxCommon
            value={2}
            valueSelected={phonePrincipal}
            onValueSelected={(val) => setPhonePrincipal(val)}
            text="Telefone principal"
          />
        ) : null}
        <Styles.Text style={{ margin: "8px 0 0 0" }}>Telefone 3</Styles.Text>
        <InputCommon
          isDisabled={!isCorretor}
          isError={false}
          type="phone"
          placeholder="Telefone 3"
          helperText=""
          value={phone3}
          onChange={(event: string) => {
            setPhone3(event);
          }}
        />
        {isCorretor ? (
          <ComboBoxCommon
            value={3}
            valueSelected={phonePrincipal}
            onValueSelected={(val) => setPhonePrincipal(val)}
            text="Telefone principal"
          />
        ) : null}
      </Styles.ContentModal>
      <Styles.Footer>
        <Styles.FooterDialog>
          <Styles.Button
            style={{ width: "100%" }}
            variant="outlined"
            onClick={() => {
              props.closeModal();
            }}
          >
            Fechar
          </Styles.Button>
          {isCorretor ? (
            <Styles.SaveButton
              style={{
                width: "100%",
                background: "#4a76fb",
                boxShadow: "none",
                color: "#fff !important",
              }}
              onClick={() => {
                mutate();
              }}
            >
              {isLoading ? <BeatLoader color="#fff" size={10} /> : "Salvar"}
            </Styles.SaveButton>
          ) : null}
        </Styles.FooterDialog>
      </Styles.Footer>
    </>
  );
};

export default LeadPhonesModal;
